import { addYears, isValid } from 'date-fns';
import { z } from 'zod';

import { toDate, type DateInput } from '@/lib/dates';

/** Valeurs du formulaire « Tiers payeur ». */
export interface ChangeTiersPayeurValues {
    /** `P` (personne physique) ou `M` (personne morale). */
    type: string;
    firstname: string;
    lastname: string;
    birthname: string;
    birthdate: DateInput;
    birthcity: string;
    birthcountry?: string;
    relationship: string;
    third_payeur_reason: string;
    pays?: string;
    ville?: string;
}

/** Contrôle du tiers payeur (ancien `ChangeTiersPayeur/validate.js`). */
export const changeTiersPayeurSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Record<string, unknown>;
    const errors: Record<string, string> = {};

    if (!v.type) {
        errors.type = 'Le champ est obligatoire';
    } else {
        let requiredFields: string[];

        if (v.type === 'P') {
            requiredFields = ['firstname', 'lastname', 'birthname', 'birthdate', 'birthcountry', 'birthcity', 'relationship'];

            if (v.relationship && v.relationship === 'A') {
                requiredFields.push('third_payeur_reason');
            }
            if (v.birthdate !== undefined) {
                const birthdate = toDate(v.birthdate as DateInput);
                if (!isValid(birthdate) || addYears(birthdate, 14).getTime() >= Date.now()) {
                    errors.birthdate = 'Le tiers payeur doit avoir au moins 14 ans.';
                }
            }
        } else {
            requiredFields = ['lastname'];
        }

        requiredFields.forEach((field) => {
            if (!v[field] && field === 'birthcountry') {
                errors[field] = 'Le champ est obligatoire, veuillez sélectionner un pays dans la liste';
            } else if (!v[field]) {
                errors[field] = 'Le champ est obligatoire';
            }
        });
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
